import { ImagableInterface } from '@/types/models'

const FIREBASE_STORAGE_BASE_URL = 'https://firebasestorage.googleapis.com/v0'

const getFirebaseStoragePathWithSize = (fullpath: string, size?: number) => {
  let sizeStr = size?.toString()
  if (sizeStr) sizeStr = `_${sizeStr}x${sizeStr}` // TODO: deal with file extensions
  return fullpath + (sizeStr || '')
}

export const getFirebaseStorageUrl = (
  bucket: string,
  fullpath: string,
  token: string,
  size?: number
): string =>
  `${FIREBASE_STORAGE_BASE_URL}/b/${bucket}/o/${encodeURIComponent(
    getFirebaseStoragePathWithSize(fullpath, size)
  )}?alt=media&token=${token}`

export const getImageUrl = (
  { bucket, fullpath, token }: ImagableInterface,
  size?: number
): string =>
  `${FIREBASE_STORAGE_BASE_URL}/b/${bucket}/o/${encodeURIComponent(
    getFirebaseStoragePathWithSize(fullpath, size)
  )}?alt=media&token=${token}`
